import React from 'react';
import { HiExclamationCircle } from 'react-icons/hi';

interface UnsavedChangesIndicatorProps {
  hasUnsavedChanges: boolean;
  className?: string;
}

const UnsavedChangesIndicator: React.FC<UnsavedChangesIndicatorProps> = ({ 
  hasUnsavedChanges, 
  className = '' 
}) => {
  if (!hasUnsavedChanges) return null;

  return (
    <div className={`flex items-center gap-2 text-amber-600 dark:text-amber-400 ${className}`}>
      <HiExclamationCircle className="text-lg animate-pulse" />
      <span className="text-sm font-medium">You have unsaved changes</span>
    </div>
  );
};

export default UnsavedChangesIndicator;